import React from 'react'
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const LinkButton = (props) => {
    const {
        history,
        location,
        match,
        statictContext,
        to,
        onClick,
        ...rest
    } = props;

    return (
        <button
            {...rest}
            onClick={(event) => {
                onClick && onclick(event)
                history.push(to)
            }}
        />
    )
}

LinkButton.propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
}

export default withRouter(LinkButton)
